import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { BrandingSettings } from 'rev-portal/branding/BrandingSettings.Contract';
import { ThemeService } from 'rev-portal/branding/Theme.Service';

import { IRules } from 'rev-shared/ui/css/CssRules.Contract';

import styles from './video-categories.module.less';

@Component({
	selector: 'categories-and-tags-style',
	template: `<ng-template [vbCssRules]="themeStyleOverrides"></ng-template>`
})
export class CategoriesAndTagsStyleComponent implements OnInit, OnDestroy {

	public readonly styles = styles;

	public themeServiceSub: Subscription;
	public themeStyleOverrides: IRules;

	constructor(
		private ThemeService: ThemeService
	) { }

	public ngOnInit(): void {
		this.themeServiceSub = this.ThemeService.brandingSettings$.subscribe(brandingSettings => this.applyCssRules(brandingSettings));
	}

	public ngOnDestroy(): void {
		this.themeServiceSub?.unsubscribe();
	}

	public applyCssRules(brandingSettings: BrandingSettings): void {
		const themeAccentColor = brandingSettings.themeSettings.accentColor;
		const themeAccentFontColor = brandingSettings.themeSettings.accentFontColor;
		this.themeStyleOverrides = {
			[`
				.${styles.item}:hover,
				.${styles.item}:hover a,
				.${styles.item} a:hover
			`]: {
				'background-color': themeAccentColor,
				'color': themeAccentFontColor,
				'text-decoration': 'none'
			}
		};
	}
}
